<template>
  <div>
    <Modal v-model="isShow" @on-ok="ok" :loading="loading" :mask-closable="false">
      <h3 slot="header" class="modal-header">项目头图</h3>
      <div v-if="data">
        <img class="imgwidth" v-if="data.projectHeadImg"  :src="data.projectHeadImg"/>
        <Upload class="upload"
                :action="baseUrl+'/file/uploadFile'"
                :on-success="handleSuccess"
                :headers="{'Access-Token':token}"
                :show-upload-list="false"
                :on-error="handleError"
                :format="['jpg','jpeg','png']"
                :on-format-error="formatError"


        >
          <Icon type="ios-plus-empty" size="40" style="vertical-align: middle"></Icon>
        </Upload>
      </div>
    </Modal>
  </div>

</template>

<script>
  import {getProjectConfigInfo,saveProjectConfigInfo} from "../../../../api/projectConfig";
  import {getBaseUrl} from "../../../../utils/public";
  import {getToken} from "../../../../utils/auth";

  export default {
    name: "HeadImg",
    props:{
      n: {
        type: Number,
        default: 0
      },
      fid:{
        type:String,
        default:''
      }
    },
    watch:{
      n(){
        this.data=null
        this.getProjectConfigInfo()
        this.isShow=true
      },
      // fid(){
      //   // this.getProjectConfigInfo()
      // }

    },
    data(){
      return {
        isShow:false,
        token: '',
        baseUrl: '',
        data:null,
        loading:true
      }
    },
    methods:{
      formatError(){
        this.$Message.info('请上传图片类型文件')
      },
      ok(){
        if(!this.fid || !this.data.projectHeadImg){
          this.isShow = false
          return
        }
        saveProjectConfigInfo(this.data).then(res=>{
          this.$Message.success('项目头图保存成功')
          this.isShow=false
        }).catch(error=>{})
      },

      handleError(){

      },
      handleSuccess(response){
        this.data.projectHeadImg = response.data.url
      },
      getProjectConfigInfo(){
        if(!this.fid){
          return
        }
        var params={
          fid:this.fid
        }
        getProjectConfigInfo(params).then(res=>{
          this.data=res.data
        }).catch(error=>{})
      }
    },
    created(){
      // this.getProjectConfigInfo()
      this.baseUrl = getBaseUrl()
      this.token = getToken()
    }

  }
</script>

<style scoped>
  .imgwidth{
    width: 150px;
    height: 100px;
    vertical-align: middle;
  }
  .upload {
    display: inline-block;
    width: 150px;
    height: 100px;
    border: 1px dashed rgb(220, 220, 220);
    box-sizing: border-box;
    text-align: center;
    line-height: 100px;
    vertical-align: middle;
  }

</style>
